document.addEventListener("DOMContentLoaded", () => {
  // Constants for class names and selectors
  const SELECTORS = {
    model: {
      item: ".models-selector__section__item",
      container: ".model-container",
      overviewItem: ".models-overview-item",
    },
    finish: {
      item: ".finishes-selector__section__subsection__item",
      container: ".finish-container",
      overviewItem: ".finishes-overview-item",
    },
  }

  const CLASSES = {
    categoryActive: "elements-selector__category--active",
    model: {
      active: "models-selector__section__item--active",
    },
    finish: {
      active: "finishes-selector__section__subsection__item--active",
    },
  }

  // DOM elements
  const elements = {
    model: {
      selector: document.getElementById("model-selector"),
      grid: document.getElementById("model-grid"),
      container: document.getElementById("models-container"),
      overview: document.getElementById("models-overview"),
    },
    finish: {
      selector: document.getElementById("finish-selector"),
      grid: document.getElementById("finish-grid"),
      container: document.getElementById("finishes-container"),
      overview: document.getElementById("finishes-overview"),
    },
    backToOverview: document.getElementById("back-to-overview"),
  }

  if (!elements.model.selector) return

  // State
  let isAutoClick = true
  const lastSelected = {
    model: null,
    finish: null,
  }

  // Utility functions
  const updateLocaleLinks = (codename) => {
    if (!window.baseFrontPath) return

    document.querySelectorAll("a[hreflang]").forEach((link) => {
      const lang = link.getAttribute("hreflang")
      if (window.baseFrontPath[lang]) {
        link.href = `${window.baseFrontPath[lang]}/${codename}`
      }
    })
  }

  const hideAllContainers = (selector) => {
    document.querySelectorAll(selector).forEach((container) => {
      container.style.display = "none"
    })
  }

  const showContainer = (id) => {
    const container = document.getElementById(id)
    if (container) container.style.display = "block"
  }

  const removeActiveClass = (selector, className) => {
    document
      .querySelectorAll(selector)
      .forEach((item) => item.classList.remove(className))
  }

  const scrollToElement = (id, block = "center") => {
    const element = document.getElementById(id)

    if (element) {
      element.scrollIntoView({ behavior: "smooth", block })
    }
  }

  const updateHistory = (url, codename) => {
    window.history.pushState({}, "", url)
    updateLocaleLinks(codename)
  }

  // Selection handlers
  const selectItem = (config) => {
    const { codename, category } = config
    const categoryConfig = SELECTORS[category]
    const categoryClass = CLASSES[category]

    hideAllContainers(categoryConfig.container)
    showContainer(`${category}-${codename.toLowerCase()}-container`)

    removeActiveClass(categoryConfig.item, categoryClass.active)

    const element = document.querySelector(
      `${categoryConfig.item}[data-model="${codename}"]`,
    )

    if (element) {
      element.classList.add(categoryClass.active)
    }

    return element
  }

  const handleItemClick = (element, codename) => {
    const shouldScroll = !isAutoClick || window.frontCodename

    if (shouldScroll) {
      scrollToElement(`${codename}-info-icon`)
      updateHistory(element.getAttribute("data-url"), codename)
    }

    isAutoClick = false
  }

  const setCategoryView = (category, codename = null) => {
    const categoryElements = elements[category]

    if (codename) {
      // Show specific item content
      selectItem({ codename, category })
      categoryElements.grid.style.display = "flex"
      categoryElements.container.style.display = "block"
      categoryElements.overview.style.display = "none"
      elements.backToOverview.style.display = "block"
    } else {
      // Show overview
      categoryElements.grid.style.display = "none"
      categoryElements.container.style.display = "none"
      categoryElements.overview.style.display = "block"
      elements.backToOverview.style.display = "none"
    }
  }

  const resetCategory = (category) => {
    const categoryElements = elements[category]
    const categorySelectors = SELECTORS[category]
    const categoryClasses = CLASSES[category]

    hideAllContainers(categorySelectors.container)
    removeActiveClass(categorySelectors.item, categoryClasses.active)

    categoryElements.grid.style.display = "none"
    categoryElements.container.style.display = "none"
    categoryElements.overview.style.display = "none"
  }

  const switchCategory = (category) => {
    isAutoClick = false

    const otherCategory = category === "model" ? "finish" : "model"
    const categoryLastSelected = lastSelected[category]

    const activeSelector = elements[category].selector
    const inactiveSelector = elements[otherCategory].selector

    activeSelector.classList.add(CLASSES.categoryActive)
    inactiveSelector.classList.remove(CLASSES.categoryActive)

    let targetUrl = activeSelector.getAttribute("data-url")
    let urlCodename = category === "model" ? "" : "finish"

    // Hide other category
    resetCategory(otherCategory)

    // Show current category (either with last selected item or overview)
    if (categoryLastSelected) {
      const restoredElement = selectItem({
        codename: categoryLastSelected,
        category,
      })
      if (restoredElement) {
        targetUrl = restoredElement.getAttribute("data-url")
        urlCodename = categoryLastSelected
        setCategoryView(category, categoryLastSelected)
      }
    } else {
      setCategoryView(category)
    }

    updateHistory(targetUrl, urlCodename)
  }

  const handleCategoryItemClick = (category, item) => {
    const codename = item.getAttribute("data-model")

    setCategoryView(category, codename)
    lastSelected[category] = codename
    handleItemClick(item, codename)
  }

  const handleCategoryOverviewItemClick = (category, item) => {
    const codename = item.getAttribute("data-model")

    setCategoryView(category, codename)
    lastSelected[category] = codename

    // Find the corresponding grid item to get its URL
    const gridItem = document.querySelector(
      `${SELECTORS[category].item}[data-model="${codename}"]`,
    )
    if (gridItem) {
      scrollToElement(`${codename}-info-icon`)
      updateHistory(gridItem.getAttribute("data-url"), codename)
    }
  }

  // Event listeners setup
  const setupCategoryListeners = (category) => {
    // Regular item listeners
    document.querySelectorAll(SELECTORS[category].item).forEach((item) => {
      item.addEventListener("click", () =>
        handleCategoryItemClick(category, item),
      )
    })

    // Overview item listeners
    document
      .querySelectorAll(SELECTORS[category].overviewItem)
      .forEach((item) => {
        item.addEventListener("click", () =>
          handleCategoryOverviewItemClick(category, item),
        )
      })

    // Category selector listener
    elements[category].selector.addEventListener("click", () =>
      switchCategory(category),
    )
  }

  // Setup listeners for both categories
  setupCategoryListeners("model")
  setupCategoryListeners("finish")

  // Back to overview button handler
  elements.backToOverview
    .querySelector("button")
    .addEventListener("click", () => {
      const activeCategory = elements.model.selector.classList.contains(
        CLASSES.categoryActive,
      )
        ? "model"
        : "finish"

      // Clear selection and show overview
      lastSelected[activeCategory] = null
      resetCategory(activeCategory)
      setCategoryView(activeCategory)

      // Update history and scroll
      const urlCodename = activeCategory === "model" ? "" : "finish"
      updateHistory(
        elements[activeCategory].selector.getAttribute("data-url"),
        urlCodename,
      )
      scrollToElement(
        elements[activeCategory].selector.getAttribute("id"),
        "start",
      )
    })

  // Initial setup based on URL codename
  const selectedCodename = window.frontCodename

  if (selectedCodename) {
    isAutoClick = false

    // Check if this is a category selector (like "finish")
    const categoryElement = document.getElementById(
      `${selectedCodename}-selector`,
    )

    if (categoryElement) {
      categoryElement.click()
    } else {
      // Find which category the item belongs to and click it
      const categories = ["model", "finish"]
      for (const category of categories) {
        const itemElement = document.querySelector(
          `${SELECTORS[category].item}[data-model="${selectedCodename}"]`,
        )
        if (itemElement) {
          if (category === "finish") {
            elements.finish.selector.click()
          }
          itemElement.click()
          break
        }
      }
    }
  } else {
    switchCategory("model")
  }
})
